module.exports = __webpack_public_path__ + "static/20200713_161817-246adb5caf400b00c4e48a077165e1d4.jpg";